import axiosInstance from "./axiosInstance";
import { CIRCUITS_Url, EXTERNAL_USER_Url } from "../const/URL";
import { ICustomerCircuitGroup } from "../interfaces/customerCircuitGroup";
import hasRequestError, { throwErrorMessage } from "../util/hasRequestError";
import { assignedGroups } from "../interfaces/assignedGroups";
import { ICustomerAccountGroup } from "../interfaces/customerAccountGroup";

export const getCustomerCircuitGroups = (
  customerId: number
): Promise<ICustomerCircuitGroup[]> => {
  return axiosInstance
    .get(`${CIRCUITS_Url}/customer/${customerId}`)
    .then((res) => {
      throwErrorMessage(res);
      return res.data.dataBundle as ICustomerCircuitGroup[];
    });
};

export const getUserCircuitGroups = (
  userId: string
): Promise<ICustomerCircuitGroup[]> => {
  return axiosInstance.get(`${CIRCUITS_Url}/users/${userId}`).then((res) => {
    throwErrorMessage(res);
    return res.data.dataBundle as ICustomerCircuitGroup[];
  });
};

export const getCustomerAccountGroups = (
  customerId: number
): Promise<ICustomerAccountGroup[]> => {
  return axiosInstance
    .get(`${EXTERNAL_USER_Url}/account-numbers`)
    .then((res) => {
      throwErrorMessage(res);
      return res.data.dataBundle as ICustomerAccountGroup[];
    });
};

export const getUserAccountGroups = (
  customerId: number
): Promise<ICustomerAccountGroup[]> => {
  return axiosInstance
    .get(`${EXTERNAL_USER_Url}/account-numbers/${customerId}`)
    .then((res) => {
      throwErrorMessage(res);
      return res.data.dataBundle as ICustomerAccountGroup[];
    });
};

// export const allocateCircuitGroup = (userID: string, circuitsGroupId: string): Promise<assignedGroups> => {
//     return axiosInstance
//         .post(`${EXTERNAL_USER_Url}/circuit`, {
//             'userId': userID,
//             'circuitsIds': [circuitsGroupId]
//         })
//         .then((res) => {
//             if (hasRequestError(res)) {
//                 throw new Error(res.data.result || res.data.message);
//             }
//             return res.data as assignedGroups;
//         });
// };

export const allocateCircuitGroup = (
  userID: number,
  circuitsGroupId: string
): Promise<assignedGroups> => {
  const url = `${EXTERNAL_USER_Url}/circuit`;
  const payload = {
    userId: userID,
    circuitsIds: [circuitsGroupId],
  };

  return axiosInstance
    .post(url, payload)
    .then((res) => {
      if (hasRequestError(res)) {
        const errorMessage =
          res.data.errorMessage || "Failed to allocate circuit group";
        throw new Error(errorMessage);
      }
      return res.data as assignedGroups;
    })
    .catch((err) => {
      console.error("Full Error Response:", err.response);
      if (err.response) {
        let errorMessage = err.response.data.errorMessage || "Server error";
        if (errorMessage.includes("SQLGrammarException")) {
          errorMessage = "A database error occurred. Please try again later.";
        }
        throw new Error(errorMessage);
      } else if (err.request) {
        throw new Error("No response from the server");
      } else {
        throw new Error("Request setup error: " + err.message);
      }
    });
};

export const allocateAccountGroup = (
  userID: number,
  accountGroupId: string
): Promise<assignedGroups> => {
  const url = `${EXTERNAL_USER_Url}/assign-account`;
  const payload = {
    userId: userID,
    accountNumbers: [accountGroupId],
  };

  return axiosInstance
    .post(url, payload)
    .then((res) => {
      if (hasRequestError(res)) {
        const errorMessage =
          res.data.errorMessage || "Failed to allocate circuit group";
        throw new Error(errorMessage);
      }
      return res.data as assignedGroups;
    })
    .catch((err) => {
      console.error("Full Error Response:", err.response);
      if (err.response) {
        let errorMessage = err.response.data.errorMessage || "Server error";
        if (errorMessage.includes("SQLGrammarException")) {
          errorMessage = "A database error occurred. Please try again later.";
        }
        throw new Error(errorMessage);
      } else if (err.request) {
        throw new Error("No response from the server");
      } else {
        throw new Error("Request setup error: " + err.message);
      }
    });
};

export const deAllocateCircuitGroup = (
  userID: string,
  circuitsGroupId: string | undefined
): Promise<void> => {
  return axiosInstance
    .post(`${EXTERNAL_USER_Url}/circuit-deallocate`, {
      userId: userID,
      circuitsIds: [circuitsGroupId],
    })
    .then((res) => {
      if (hasRequestError(res)) {
        throw new Error(res.data.result || res.data.message);
      }
      return Promise.resolve();
    });
};

export const deAllocateAccountGroup = (
  userID: string,
  accountGroupId: string | undefined
): Promise<void> => {
  return axiosInstance
    .post(`${EXTERNAL_USER_Url}/deallocate-account`, {
      userId: userID,
      accountNumbers: [accountGroupId],
    })
    .then((res) => {
      if (hasRequestError(res)) {
        throw new Error(res.data.result || res.data.message);
      }
      return Promise.resolve();
    });
};
